module.exports = __webpack_public_path__ + "img/store_lzcjdx.754db380.jpeg";